export const getCivilServiceLawCaseRejectionCategorySelectOptions = () => [
  { value: "none" },
  { value: "individual" },
  { value: "opponentNonEu" },
  { value: "specialistLawyerNeeded" },
  { value: "enforceClaimTimeBarred" },
  { value: "unlikelySuccessful" },
];
